import React, { useContext } from 'react';
import Head from 'next/head';
import generateMetaData from 'lib/utils/generateMetaData';
import { StyledBox } from 'views/rebranded-module/membership-module/MembershipLandingViewV2/MembershipLandingViewV2.styles';
import {
  AvailableBikesSection,
  AvailableBikesSectionSkeleton,
} from 'views/rebranded-module/membership-module/MembershipLandingViewV2/components/AvailableBikesSection';
import { Box, Container, Divider } from '@mui/material';
import {
  MembershipBenefitsSection,
  MembershipBenefitsSectionSkeleton,
} from 'views/rebranded-module/membership-module/MembershipLandingViewV2/components/MembershipBenefitsSection';
import {
  MembershipPlansSection,
  MembershipPlansSectionSkeleton,
} from 'views/rebranded-module/membership-module/MembershipLandingViewV2/components/MembershipPlansSection';
import { useContent } from 'views/rebranded-module/common/context/useContent';
import {
  HeroSection,
  WhyJoinSection,
  WhyJoinSectionSkeleton,
  UltimateTestRideSection,
  UltimateTestRideSectionSkeleton,
  HowItWorksSection,
  HowItWorksSectionSkeleton,
  KnowBeforeRideSection,
  KnowBeforeRideSectionSkeleton,
  FAQSSection,
  FAQSSectionSkeleton,
} from 'views/rebranded-module/membership-module/MembershipLandingViewV2/components';
import { LazyLoad } from 'views/common/components';
import {
  ParticipatingLocationsWrapper,
  ParticipatingLocationsSkeleton,
} from 'views/rebranded-module/common/components';

const MembershipLandingViewV2: React.FC<any> = (props) => {
  const { serverData: membershipData } = props;
  const cmsData = useContent();
  return (
    <StyledBox>
      <Head>
        {membershipData?.seo_values &&
          generateMetaData(membershipData.seo_values)}
      </Head>
      <HeroSection />
      <LazyLoad skeleton={<WhyJoinSectionSkeleton />} dataLoaded>
        <WhyJoinSection />
      </LazyLoad>
      <Container maxWidth="xl">
        <LazyLoad skeleton={<UltimateTestRideSectionSkeleton />} dataLoaded>
          <UltimateTestRideSection />
        </LazyLoad>
      </Container>

      <LazyLoad skeleton={<HowItWorksSectionSkeleton />} dataLoaded>
        <HowItWorksSection />
      </LazyLoad>
      <Container maxWidth="xl">
        <Box id="plans-comparison-section">
          <LazyLoad skeleton={<MembershipPlansSectionSkeleton />} dataLoaded={membershipData}>
            <MembershipPlansSection  plansData ={membershipData.memberships}/>
          </LazyLoad>
        </Box>
        <Box pt={10} pb={14} className="MLVSpacingMobile">
          <LazyLoad skeleton={<MembershipBenefitsSectionSkeleton />} dataLoaded>
            <MembershipBenefitsSection />
          </LazyLoad>
        </Box>
      </Container>

      <Divider className="MLVDivider" />

      <Container maxWidth="xl">
        <Box py={16} className="MLVSpacingMobile">
          <LazyLoad
            skeleton={<AvailableBikesSectionSkeleton />}
            dataLoaded={membershipData}>
            <AvailableBikesSection
              selectedLocation={membershipData.selected_location}
              availableBikes={membershipData.available_vehicle_models}
              blackoutDates={membershipData.blackout_calendars}
              particpatingLocations={membershipData.participating_locations}
            />
          </LazyLoad>
        </Box>
        <Box className="MLVParicipationSectionSpacing">
          <LazyLoad
            skeleton={<ParticipatingLocationsSkeleton />}
            dataLoaded={membershipData}>
            <ParticipatingLocationsWrapper
              mapGroupData={membershipData.geography_component}
              content={cmsData.ParticipatingLocationsComponent}
              placeholder={
                cmsData.ParticipatingLocationsComponent.searchInputPlaceholder
              }
              target="_blank"
              showExternalLink={true}
            />
          </LazyLoad>
        </Box>
      </Container>

      <LazyLoad skeleton={<KnowBeforeRideSectionSkeleton />} dataLoaded>
        <KnowBeforeRideSection />
      </LazyLoad>
      <Container maxWidth="xl">
        <LazyLoad
          skeleton={<FAQSSectionSkeleton />}
          dataLoaded={membershipData}>
          <FAQSSection faqs={membershipData.faq_items} />
        </LazyLoad>
      </Container>
    </StyledBox>
  );
};

export { MembershipLandingViewV2 };
